<template>
  <div>
    <div class="main-button-bar">
      <el-select
        v-model="userId"
        filterable
        remote
        reserve-keyword
        placeholder="请输入员工名称"
        :remote-method="search"
        size="small"
      >
        <el-option
          v-for="item in users"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        @click="createGrade"
        v-show="userId != null"
        >变更积分</el-button
      >
    </div>
    <el-divider></el-divider>
    <user-grade-detail :userId="userId" ref="UserGradeDetail"/>

    <el-dialog :visible.sync="showAddDialog" title="积分变更" width="30%">
      <el-form
        label-width="60px"
        label-position="top"
        :rules="rules"
        :model="grade"
        ref="grade"
      >
        <el-form-item label="变动积分" prop="changeGrade">
          <el-input v-model.number="grade.changeGrade" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="原因" prop="remark">
          <el-input
            v-model="grade.remark"
            autocomplete="off"
            type="textarea"
            rows="5"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="docreateGrade" class="add-grade-button">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UserGradeDetail from "./User-grade-detail.vue";

export default {
  components: { UserGradeDetail },
  data() {
    return {
      users: [],
      userId: null,
      showAddDialog: false,
      grade: {},
      rules: {
        changeGrade: [
          { required: true, message: "请输入变动积分" },
          { message: "积分必须是数字", type: "number" },
        ],
        remark: [
          { required: true, message: "请输入变动原因" },
          { message: "限制1000个文字", min: 1, max: 1024 },
        ],
      },
    };
  },
  methods: {
    search(query) {
      let _this = this;

      _this.$http.post(
        ["/user/searchByName", { name: query }],
        [
          function (data) {
            _this.users = data;
          },
        ], "none"
      );
    },
    createGrade() {
      this.showAddDialog = true;
    },
    docreateGrade() {
      let _this =  this;

      _this.$http.post(["user/grade/create", _this.grade, {userId: _this.userId}], [function(){
        _this.showAddDialog = false;
        _this.$refs.UserGradeDetail.searchGrade(_this.userId, {});
      }], ".add-grade-button")
    }
  },
};
</script>

<style scoped>
.grade-search {
  margin-left: 10px;
}
.grade-main {
  margin-left: 10px;
}
.grade-main-head {
  height: 30px;
}
.grade-main-head > div {
  float: left;
}
.grade-main-rate {
  width: 300px;
  margin-left: 10px;
}
.grade-main-time {
  overflow-x: hidden;
}
.grade-card {
  width: 500px;
}
.grade-card-remark {
  height: 150px;
}
.grade-card-totle {
  color: #409eff;
  float: right;
}
.grade-card-change {
  color: red;
}
</style>